<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <h1 class="error-title">Page non trouvée</h1>
      <p class="error-message">
        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <div class="action-buttons">
        <router-link to="/" class="btn btn-primary">
          Retour à l'accueil
        </router-link>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    isAuthenticated() {
      return !!localStorage.getItem('token');
    }
  }
};
</script>

<style scoped>
.not-found-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.not-found-content {
  text-align: center;
  max-width: 600px;
  background: white;
  padding: 60px 40px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.error-code {
  font-size: 120px;
  font-weight: 900;
  color: #1e347d;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.error-title {
  font-size: 32px;
  font-weight: bold;
  color: #1e347d;
  margin-bottom: 15px;
}

.error-message {
  font-size: 18px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.6;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-primary {
  background-color: #ec621a;
  color: white;
  border: 2px solid #ec621a;
}

.btn-primary:hover {
  background-color: #d55617;
  border-color: #d55617;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(236, 98, 26, 0.3);
}

.btn-secondary {
  background-color: transparent;
  color: #1e347d;
  border: 2px solid #1e347d;
}

.btn-secondary:hover {
  background-color: #1e347d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(30, 52, 125, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .not-found-content {
    padding: 40px 30px;
  }

  .error-code {
    font-size: 80px;
  }

  .error-title {
    font-size: 24px;
  }

  .error-message {
    font-size: 16px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .not-found-content {
    padding: 30px 20px;
  }

  .error-code {
    font-size: 60px;
  }

  .error-title {
    font-size: 20px;
  }

  .error-message {
    font-size: 14px;
  }
}
</style>
